import * as $ from 'jquery';
import 'bootstrap';
import 'selectize';
import 'datepicker';
require('datatables.net');
require('datatablesResponsive');
require('parsley');

export class contactForm {

	/**
	 * initialize all form inputs[text] with focus and filled effects
	 * @param  {any} inputElArr [description]
	 * @return {any}            [description]
	 */
	initFormTextInputs(inputElArr:any): any {
		for (var i=0, len=inputElArr.length; i<len; i++) {
			if (!inputElArr[i].classList.contains('datepicker')) { // exclude datepicker input fields
				$(inputElArr[i])
				.on('focus', function(e:any){
					let $this:any = $(this);
					$this.addClass('input-focused').removeClass('has-error');
					$this.parent().addClass('input-focused');
					$this.parent().find('label').addClass('input-filled').removeClass('has-error');
				})
				.on('blur', function(e:any){
					let $this:any = $(this);
					if ($this.val() == '') {
						$this.removeClass('input-focused');
						$this.parent().removeClass('input-focused');
						$this.parent().find('label').removeClass('input-filled');
					}
					else {
						$this.addClass('input-focused');
						$this.parent().find('label').addClass('input-filled');
					}
				});
			}
		}
	}

	/**
	 * Init selectize elements
	 * @param  {any} inputSelectArr [description]
	 * @return {any}                [description]
	 */
	initSelectizeInputs(inputSelectArr:any): any {
		for (var i=0, len=inputSelectArr.length; i<len; i++) {
			if (!inputSelectArr[i].classList.contains('countrycode-input')) {
				let $this:any      = $(inputSelectArr[i]);
				let $thisSelectize:any = $this.parent();
				let $thisLabel:any = $this.parent().find('label');
				$this.selectize({
					valueField: 'value',
					labelField: 'text',
					searchField: ['text'],
					selectOnTab: true,
					onInitialize: () => {
						$this[0].selectize.$control_input.attr('name', $this[0].selectize.$input[0].id.split('--')[1]);
						$this[0].selectize.$control_input.attr('data-parsley-errors-container', '#' + $this[0].selectize.$input[0].id + '--error-container');
					},
					onFocus: () =>  {
						$thisLabel.addClass('input-filled');
						$($this[0].selectize.$control[0]).addClass('select-filled');
					},
					onChange: (value: any) =>  {
						$thisLabel.addClass('input-filled');
						$($this[0].selectize.$control[0]).addClass('select-filled');
						$('#reservation-category-val').val(value);
						if (value=='') {
							$thisSelectize.addClass('has-error');
							if ($('#error--contact--reservation-category-selectized').length) {
								$('#error--contact--reservation-category-selectized').show()
							}
						} else {
							$thisSelectize.removeClass('has-error');
							if ($('#error--contact--reservation-category-selectized').length) {
								$('#error--contact--reservation-category-selectized').hide()
							}
						}
					},
					onBlur: () => {
						let $activeOptionChange:any = $this[0].selectize.getValue();
						if ($activeOptionChange == null || !$activeOptionChange.length) {
							$thisLabel.removeClass('input-filled');
							$($this[0].selectize.$control[0]).removeClass('select-filled');
						} else {
							$thisLabel.addClass('input-filled');
							$($this[0].selectize.$control[0]).addClass('select-filled');
						}
					},
				});
			}
		}
	}

	/**
	 * [initDatepickerInputs description]
	 * @param  {any}     inputElArr    [description]
	 * @param  {Date}    minDate       [description]
	 * @param  {Date}    maxDate       [description]
	 * @param  {boolean} beforeShowDay [description]
	 * @param  {any}     beforeShowFn  [description]
	 * @return {any}                   [description]
	 */
	initDatepickerInputs(
		inputElArr:any,
		minDate:Date,
		maxDate:Date,
		beforeShowDay:boolean,
		beforeShowFn:any): any {
		for (var i=0, len=inputElArr.length; i<len; i++) {
			let $this:any      = $(inputElArr[i]);
			let $thisLabel:any = $this.parent().find('label');

			let params:any = {
	          dateFormat: 'd M yy',
	          numberOfMonths: 2,
	          yearRange: "-90:+90",
	          onSelect : function(dateText:string, instance:any) {
				$this.parent().addClass('input-focused');
				$this.addClass('input-focused').removeClass('has-error');
				$thisLabel.addClass('input-filled').removeClass('has-error');
	          	// console.log(dateText, instance);
	          },
	          beforeShow: function( input:any, inst:any){
			    $(inst.dpDiv).addClass('contact-date');
			  }
			};

			if (minDate !== undefined) {
				params['minDate'] = minDate;
			}

			if (maxDate !== undefined) {
				params['maxDate'] = maxDate;
			}

			if (beforeShowDay !== undefined) {
				params['beforeShowDay'] = beforeShowDay;
			}

			if (beforeShowFn !== undefined) {
				params['beforeShowFn'] = beforeShowFn;
			}

			$(inputElArr[i]).attr('readonly', 'readonly');
			$(inputElArr[i]).datepicker(params);
		}
	}

	/**
	 * [initPhoneInput description]
	 * @param  {any} inputElArr [description]
	 * @return {any}            [description]
	 */
	initPhoneInput(inputElArr:any):any {
		for (var i=0, len=inputElArr.length; i<len; i++) {
			let $this:any = inputElArr[i];
			let $cunCodeInput:any = $(inputElArr[i]).find('.phoneinput__countrycode select');
			let $cunCodeLabel:any = $(inputElArr[i]).find('.phoneinput__countrycode label');
			let $phoneLabel:any   = $(inputElArr[i]).find('.phoneinput__phonenumber label');
			let $phoneInput:any   = $(inputElArr[i]).find('.phoneinput__phonenumber input');

			// init country code field
			$cunCodeInput.selectize({
				valueField: 'text',
				labelField: 'text',
				searchField: ['text'],
				selectOnTab: true,
				onInitialize: () => {
					$cunCodeInput[0].selectize.$control_input.attr('name', $cunCodeInput[0].selectize.$input[0].id.split('--')[1]);
					$cunCodeInput[0].selectize.$control_input.attr('data-parsley-errors-container', '#' + $cunCodeInput[0].selectize.$input[0].id + '--error-container');
				},
				onFocus: () =>  {
					$cunCodeLabel.addClass('input-filled');
					$($cunCodeInput[0].selectize.$control[0]).addClass('select-filled');
				},
				onChange: () =>  {
					$cunCodeLabel.addClass('input-filled');
					$($cunCodeInput[0].selectize.$control[0]).addClass('select-filled');
				},
				onBlur: () => {
					let $activeOptionChange:any = $cunCodeInput[0].selectize.getValue();
					if ($activeOptionChange == null || !$activeOptionChange.length) {
						$cunCodeLabel.removeClass('input-filled');
						$($cunCodeInput[0].selectize.$control[0]).removeClass('select-filled');
					} else {
						$cunCodeLabel.addClass('input-filled');
						$($cunCodeInput[0].selectize.$control[0]).addClass('select-filled');
					}
				},
			});

			// init phone number field
			$phoneInput
			.on('focus', function(e:any){
				let $this:any = $(this);
				$this.addClass('input-focused').removeClass('has-error');
				$this.parent().addClass('input-focused');
				$phoneLabel.addClass('input-filled').removeClass('has-error');
			})
			.on('blur', function(e:any){
				let $this:any = $(this);
				if ($this.val() == '') {
					$this.removeClass('input-focused');
					$this.parent().removeClass('input-focused');
					$phoneLabel.removeClass('input-filled');
				}
				else {
					$this.addClass('input-focused');
					$phoneLabel.addClass('input-filled');
				}
			});
		}
	}

	/**
	 * [initRangeInput description]
	 * @param {any} inputElArr [description]
	 */
	initRangeInput(inputElArr:any) {
		for (var i=0, len=inputElArr.length; i<len; i++) {
			let $this:any = inputElArr[i];
			let $thisId:string = $this.id;
			let $thisInputId:string = $thisId.replace(/-slider/g,'');
			let $thisInput:any = $($this).parents().eq(2).find('#'+$thisInputId);
			let $thisInputLabel:any = $($thisInput).parent().find('label');

			// set input field to readonly
			$thisInput.attr('readonly', 'readonly');

			$($this).rangeslider({
				polyfill: false,

				// Callback function
				onInit: function() {},

				// Callback function
				onSlide: function(position:any, value:any) {
					$thisInputLabel.addClass('input-filled');
					$thisInput.addClass('input-focused input-filled');
					$thisInput.val(value);
					$thisInput.trigger('change'); // trigger change event
				},

				// Callback function
				onSlideEnd: function(position:any, value:any) {
				}
			});
		}
	}

	/**
	 * [initIncrementer description]
	 * @param  {any} inputElArr [description]
	 * @return {any}            [description]
	 */
	initIncrementer(inputElArr:any): any {
		for (var i=0, len=inputElArr.length; i<len; i++) {
			let el = $(inputElArr[i]);
			let btnMinus       = el.find('.incrementer__btn.incrementer--decrement');
			let btnPlus        = el.find('.incrementer__btn.incrementer--increment');
			let elDisplay      = el.find('.incrementer__display');
			let input          = el.find('input[type="hidden"]');
			let curVal:number = 0;
			let	params = {
				'min': parseInt(el[0].dataset.min),
				'max': parseInt(el[0].dataset.max),
				'initvalue': parseInt(el[0].dataset.initValue)
			};

			// console.log(el, btnMinus, btnPlus, elDisplay, input);

			// btnMinus click handler
			// - on click, increment display value & input[hidden] value
			btnMinus.on('click', function(e:any) {
				e.preventDefault();
				e.stopPropagation();

				if ("vibrate" in navigator) {
					// vibration API supported
					navigator.vibrate(25);
				}

				curVal = setIncrementer(elDisplay, input, curVal, params, 'decrement');
			});

			// btnMinus click hold handler
			// - on hold down click,
			//   automatically decrement by 1 unit per 100ms
			//   until mouseout
			let btnMinInterval:any;

			btnMinus.on('mousedown', function(e:any) {
				e.preventDefault();
				e.stopPropagation();

				btnMinInterval = setInterval(function() {
					curVal = setIncrementer(elDisplay, input, curVal, params, 'decrement');
				}, 200);
			}).on('mouseup mouseleave', function() {
				clearInterval(btnMinInterval);
			});

			// btnPlus click handler
			// - on click, increment display value & input[hidden] value
			btnPlus.on('click', function(e:any) {
				e.preventDefault();
				e.stopPropagation();

				if ("vibrate" in navigator) {
					// vibration API supported
					navigator.vibrate(35);
				}

				curVal = setIncrementer(elDisplay, input, curVal, params, 'increment');
			});

			// btnPlus click hold handler
			// - on hold down click,
			//   automatically decrement by 1 unit per 100ms
			//   until mouseout
			let btnPlusInterval:any;

			btnPlus.on('mousedown', function(e:any) {
				e.preventDefault();
				e.stopPropagation();

				// set initial delay (500ms)
				btnPlusInterval = setInterval(function() {
					curVal = setIncrementer(elDisplay, input, curVal, params, 'increment');
				}, 200);
			}).on('mouseup mouseleave', function() {
				clearInterval(btnPlusInterval);
			});
		}

		/**
		 * common function to set incrementer value/display for click/hold events
		 * @param  {any}    elDisplay [description]
		 * @param  {any}    input     [description]
		 * @param  {any}    curVal    [description]
		 * @param  {any}    params    [description]
		 * @param  {string} type      [description]
		 * @return {any}              [description]
		 */
		function setIncrementer(elDisplay:any, input:any, curVal:any, params:any, type:string):any {
			if (type == 'decrement') {
				if (curVal > params.min) {
					curVal--;
				}
			}

			if (type == 'increment') {
				if (curVal < params.max) {
					curVal++;
				}
			}

			// console.log('curVal: ', curVal);

			elDisplay.html(curVal);
			input.val(curVal);

			input.parent().trigger('incrementer.changed', [curVal]);

			return curVal;

		}
	}

	validateForm(form: any, customValidation:any, onSuccess:any): any {
		let _self = this;
		let submitBtn:any = form.find('.btn-contact--submit');
		let _window:any   = window;
		let formData:Array<any> = [];

		let validation:any = form.parsley({
			errorClass: 'has-error',
			excluded: "input[type=file]",
	        classHandler: function (el:any) {
	            return el.$element.closest('.form-item');
			}
		});

		// custom validation here
		// pass in validation instance and validation summary objects
		// for use in callback
		if (typeof customValidation === 'function') {
			customValidation(validation);
		}

		// validate on click submit
		submitBtn.on('click', function(e:any) {
			e.stopPropagation();
			e.preventDefault();

			let validationResult:any = validation.validate();

			if (validationResult) {
				if (form.find('input[type=file]').length > 0) {
					for (var i=0; i<form.find('input[type=file]').length; i++) {
						form.find('input[type=file]')[i].style.display = 'block';
					}
				}
				formData = form.find('input:not([id*="-selectized"]), select').serializeArray();
				//alert('Form submitted, view console log for params.');

				// custom validation here
				// pass in validation instance and validation summary objects
				// for use in callback
				if (typeof onSuccess === 'function') {
					onSuccess(validation, formData);
				}
			}
			// console.log(result);
		});

		displayErrorSummaryAtFormTop();

		/**
		 * Consolidate error messages and display at the top of the form
		 */
		function displayErrorSummaryAtFormTop() {
	        // When there's a click on a error message from the div
	        form.on('click', 'a[class^="focus-"]', function(){
	        	// take the field's name from the class
				let nameVal:string         = $(this).attr('class').replace(/focus-/g,'');;
				let mabHeaderHeight:number = $('#mab-header').outerHeight();
				let errorField:any         = form.find("#" + nameVal);
				let errorFieldPos:number   = 0;

	        	if (isSelectize(errorField)) {
	        		// is selectize element
	        		errorFieldPos = errorField.next().offset().top - mabHeaderHeight - $(window).scrollTop() - errorField.next().outerHeight();
	        	} else {
	        		// every other input field
		        	errorFieldPos = errorField.offset().top - mabHeaderHeight - $(window).scrollTop();
	        	}

	        	// scroll to error element
	        	$("html, body").animate({ scrollTop: errorFieldPos });

	        	// focus on the element after scrolling to it
	        	// - if selectize, click on input field to trigger dropdown open
	        	if (isSelectize(errorField)) {
		        	errorField.next().find('.selectize-input').click();
	        	} else {
		        	errorField.focus();
	        	}
	        });

			if (!document.body.getAttribute('data-form-validate-init')) {
	        	document.body.setAttribute('data-form-validate-init', '1');
				// Before each validation, clear the error-validation of the div
		        _window.Parsley.on('form:validate', function(_form:any) {

		        	// get scoped validation summary div
		        	// scoped for pages with multiple forms
					let validationSummary:any = _form.$element.find('.error-validation');

		            validationSummary.html('');
		            validationSummary.hide();
		        });
			}

			if (!document.body.getAttribute('data-field-error-init')) {
	        	document.body.setAttribute('data-field-error-init', '1');
		        // When a field has an error
		        _window.Parsley.on('field:error', function(fieldInstance:any){
		        	// console.log('field:error', fieldInstance);

		        	// get scoped validation summary div
		        	// scoped for pages with multiple forms
					let validationSummary:any = fieldInstance.parent.$element.find('.error-validation');

		            // Get the error messages
		            // var messages = _window.ParsleyUI.getErrorsMessages(fieldInstance);
		            var messages = fieldInstance.getErrorsMessages();

		            // Get the field's name
		            var fieldId = fieldInstance.$element.attr('id');
					var fieldNameRaw = fieldInstance.$element.attr('name');
					var fieldName    = fieldNameRaw.replace(/--/g, ' ');
					fieldName        = fieldName.replace(/-/g, ' ');

		            // Loop through all the messages
		            for (var i in messages) {
		                // Create a message for each error
		                var $m = $('<p id="error--'+fieldId+'"><a class="focus-' + fieldId + '" href="#">' + '<span class="field-name">' + fieldName + ': </span>' + messages[i] + '</a><p>');

		                let fieldIdExists:any = validationSummary.find('#error--'+fieldId);

		                // Append the errors to the div if not shown
		                if (fieldIdExists.length) {
		                	fieldIdExists.remove();
			                validationSummary.append($m);
		                } else {
			                validationSummary.append($m);
		                }
		            }

		        	validationSummary.show();
		        });
		    }
		}

		/**
		 * test if field is selectize input
		 * @param {any} el [jquery object - input element to test]
		 * @return boolean
		 */
		function isSelectize(el:any) {
        	if (el.prop('type') == 'select-one' && el.hasClass('selectized')) {
        		return true;
        	} else {
        		return false;
        	}
		}
	}
}
